import * as questionIds from "../../consultationQuestions/questionIds";

export const visionQuestions = [
    {
        id: questionIds.VisionUnableToCarryOut,
        questionText: "Unable to carry out medical",
    },
    {
        id: questionIds.VisionUnableToCarryOutReason,
        questionText: "Reason medical not carried out",
    },
    {
        id: questionIds.VisionTestType,
        questionText: "Test type",
    },
    {
        id: questionIds.VisionServiceDate,
        questionText: "Most recent service date",
    },
    {
        id: questionIds.VisionAge,
        questionText: "Age",
    },
    {
        id: questionIds.VisionRoleType,
        questionText: "Role type",
    },
    {
        id: questionIds.VisionLastOpticianTest,
        questionText: "Last opticians test",
    },
    {
        id: questionIds.VisionCurrentCorrectionRequired,
        questionText: "Current visual correction required",
    },
    {
        id: questionIds.VisionCurrentVisualAidDescription,
        questionText: "Description",
    },
    {
        id: questionIds.VisionCorrectivePrescriptionUsed,
        questionText: "Type of corrective prescription used",
    },
    {
        id: questionIds.VisionFamilyHistory,
        questionText: "Family history",
    },
    {
        id: questionIds.VisionHistoricalCurrentIssues,
        questionText: "Historical or current issues with eyesight",
    },
    {
        id: questionIds.VisionHistoricalCurrentIssuesYesOrNo,
        questionText: "Any historical or current issues with eyesight?",
    },
    {
        id: questionIds.VisionHistoricalCurrentIssuesDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.VisionDistanceCorrectionDistance,
        questionText: "Correction used in distance test?",
    },
    {
        id: questionIds.VisionRightEyeDistance,
        questionText: "Right eye",
    },
    {
        id: questionIds.VisionLeftEyeDistance,
        questionText: "Left eye",
    },
    {
        id: questionIds.VisionBothEyesDistance,
        questionText: "Both eyes",
    },
    {
        id: questionIds.VisionIntermediateCorrection,
        questionText: "Correction used in intermediate test?",
    },
    {
        id: questionIds.VisionBothEyesIntermediate100Cm,
        questionText: "Intermediate result (VDU 100cm)",
    },
    {
        id: questionIds.VisionBothEyesIntermediate60Cm,
        questionText: "Intermediate result (VDU 60cm)",
    },
    {
        id: questionIds.VisionNearCorrection,
        questionText: "Correction used in reading (near) test?",
    },
    {
        id: questionIds.VisionDistanceCorrectionNear,
        questionText: "Correction used in distance test?",
    },
    {
        id: questionIds.VisionRightEyeNear,
        questionText: "Right eye",
    },
    {
        id: questionIds.VisionLeftEyeNear,
        questionText: "Left eye",
    },
    {
        id: questionIds.VisionBothEyesNear,
        questionText: "Both eyes",
    },
    {
        id: questionIds.VisionNightVision,
        questionText: "Both eyes",
    },
    {
        id: questionIds.VisionColourTestType,
        questionText: "Test type",
    },
    {
        id: questionIds.VisionColourResult,
        questionText: "Results",
    },
    {
        id: questionIds.VisionLeftEyePeripheralField,
        questionText: "Left eye",
    },
    {
        id: questionIds.VisionRightEyePeripheralField,
        questionText: "Right eye",
    },
    {
        id: questionIds.VisionHorizontalField,
        questionText: "Horizontal field of vision",
    },
    {
        id: questionIds.VisionPhoriaDistance,
        questionText: "Distance",
    },
    {
        id: questionIds.VisionPhoriaNear,
        questionText: "Near",
    },
    {
        id: questionIds.VisionDepthPerceptionDistance,
        questionText: "Distance",
    },
    {
        id: questionIds.VisionDepthPerceptionNear,
        questionText: "Near",
    },
    {
        id: questionIds.VisionSafetyGlassesAdequateAndInGoodCondition,
        questionText: "Saftey glasses (if worn) adequate and in good condition?",
    },
    {
        id: questionIds.VisionRemindedToAttendOpticiansRoutinely,
        // eslint-disable-next-line max-len
        questionText: "The employee has been reminded to attend opticians test biennially (two yearly) routinely to protect eye health or as recommended by optician",
    },
    {
        id: questionIds.OpticiansSelfReferralLetterIssued,
        questionText: "Opticians self referral letter issued?",
    },
    {
        id: questionIds.EmployeeInformedGlassesAreWornToMeetMinimumStandards,
        questionText: "Employee informed that if glasses are worn to meet the minimum standards, the employee should always wear their glasses when driving",
    },
    {
        id: questionIds.EmployeeInformedGlassesAreWornToMeetMinimumStandardsAdditionalNotes,
        questionText: "Additional Notes",
    }
];
